<template>
  <div class="login-page">
    <!-- Lado Esquerdo - Informativo -->
    <div class="login-left">
      <div class="left-content">
        <!-- Logo -->
        <div class="logo-container">
          <img src="@/assets/logoDNWAYS_GREEN.png" alt="Logo" class="logo" />
        </div>

        <!-- Conteúdo Informativo -->
        <div class="info-content">
          <div class="info-icon">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="rgba(255, 255, 255, 0.1)"/>
              <path d="M32 20v24M20 32h24" stroke="white" stroke-width="3" stroke-linecap="round"/>
              <circle cx="32" cy="42" r="2" fill="white"/>
            </svg>
          </div>
          <h1 class="info-title">Sistema de Atendimento</h1>
          <p class="info-description">
            Solicite atendimento, acompanhe o status dos seus chamados e tenha acesso rápido ao suporte especializado.
          </p>

          <!-- Features -->
          <div class="features">
            <div class="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17l-5-5" stroke="#94bd23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Acompanhamento em tempo real</span>
            </div>
            <div class="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17l-5-5" stroke="#94bd23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Suporte especializado</span>
            </div>
            <div class="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17l-5-5" stroke="#94bd23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Histórico completo de chamados</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lado Direito - Formulário de Login -->
    <div class="login-right">
      <div class="login-card">
        <!-- Header do Card -->
        <div class="card-header">
          <div class="welcome-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#E1E9F7"/>
              <path d="M24 12c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM24 32c-5.3 0-16 2.7-16 8v2h32v-2c0-5.3-10.7-8-16-8z" fill="#00235C"/>
            </svg>
          </div>
          <h2 class="card-title">Faça login na sua conta</h2>
          <p class="card-subtitle">Bem-vindo de volta! Por favor, insira seus dados.</p>
        </div>

        <!-- Formulário -->
        <form class="login-form" @submit.prevent="sendLogin">
          <!-- Campo Usuário -->
          <div class="form-group">
            <label class="form-label" for="usuario">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM2 14a6 6 0 1 1 12 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              E-mail, CPF ou CNPJ
            </label>
            <input
              id="usuario"
              type="text"
              class="form-input"
              placeholder="Digite seu e-mail, CPF ou CNPJ"
              v-model="loginSession.Usuario"
              autocomplete="username"
              :class="{ 'input-error': erro }"
              @focus="erro = false; messageError = null"
            />
          </div>

          <!-- Campo Senha -->
          <div class="form-group">
            <label class="form-label" for="senha">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="7" width="10" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
                <path d="M5 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Senha
            </label>
            <input
              id="senha"
              type="password"
              class="form-input"
              placeholder="Digite sua senha"
              v-model="loginSession.Senha"
              autocomplete="current-password"
              :class="{ 'input-error': erro }"
              @focus="erro = false; messageError = null"
            />
          </div>

          <!-- Mensagem de Erro -->
          <transition name="error-fade">
            <div v-if="messageError" class="error-message">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 4v5M8 11v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              {{ messageError }}
            </div>
          </transition>

          <!-- Botão de Login -->
          <button type="submit" class="btn-login" :disabled="disableBtnLogin">
            <span v-if="!disableBtnLogin">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 2L16 9L11 16M16 9H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Entrar
            </span>
            <span v-else class="loading">
              <svg class="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="50" stroke-dashoffset="25"/>
              </svg>
              Entrando...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'UserLogin',
    data() {
        return {
            loginSession: {
                Usuario: null,
                Senha: null
            },
            disableBtnLogin: false,
            messageError: null,
            erro: false,
            nomeEmpresa: ''
        };
    },
    mounted(){
      this.disableBtnLogin = false;
      this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
        }),
        async sendLogin() {
          this.disableBtnLogin = true;
            if(this.loginSession.Usuario == '' || this.loginSession.Usuario == null){
                this.messageError = 'Verifique os dados';
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            }else if(this.loginSession.Senha == '' || this.loginSession.Senha == null){
                this.messageError = 'Verifique os dados';
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            }  

             var model = { Usuario: this.loginSession.Usuario, Senha: this.loginSession.Senha}
             await this.signIn(model)
                .then(response => {
                  this.disableBtnLogin = false;
                    if(response.status == 200){
                      this.messageError = '';
                      this.erro = false;
                      this.$router.replace({
                          path: '/',
                      });
                    }
                })
                .catch((error) => {
                  this.disableBtnLogin = false;
                        if(error.response.data == ''){
                            this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                            this.erro = true;
                        }else  if(error.response.data?.data[0] == 'Cliente não validado o e-mail!'){
                            this.messageError = 'Falha na autenticação. Confirme seu endereço de e-mail.';
                            this.erro = true;
                        }else{
                            this.messageError = error.response.data?.data[0];
                            this.erro = true;
                        }


                });


        },
    }
};

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Layout Principal */
.login-page {
  display: flex;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

/* Lado Esquerdo - Informativo */
.login-left {
  flex: 1;
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 500px;
    height: 500px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    top: -250px;
    left: -250px;
  }

  &::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50%;
    bottom: -200px;
    right: -200px;
  }
}

.left-content {
  max-width: 600px;
  z-index: 1;
  width: 100%;
}

.logo-container {
  margin-bottom: 3rem;
  animation: fadeInDown 0.6s ease;
}

.logo {
  max-width: 200px;
  height: auto;
  filter: brightness(0) invert(1);
}

.info-content {
  animation: fadeInUp 0.8s ease 0.2s backwards;
}

.info-icon {
  margin-bottom: 2rem;
  animation: scaleIn 0.6s ease 0.4s backwards;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.info-title {
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1.5rem;
  letter-spacing: -1px;
  line-height: 1.2;
}

.info-description {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  margin-bottom: 3rem;
}

.features {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  animation: fadeInLeft 0.6s ease backwards;

  &:nth-child(1) { animation-delay: 0.6s; }
  &:nth-child(2) { animation-delay: 0.7s; }
  &:nth-child(3) { animation-delay: 0.8s; }

  svg {
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.5rem;
    border-radius: 8px;
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Lado Direito - Formulário */
.login-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.login-card {
  background: white;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  width: 100%;
  max-width: 480px;
  animation: slideUp 0.6s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.welcome-icon {
  margin-bottom: 1.5rem;
  display: inline-block;
  animation: scaleIn 0.6s ease 0.3s backwards;
}

.card-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.75rem;
  letter-spacing: -0.5px;
}

.card-subtitle {
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.5;
}

/* Formulário */
.login-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;

  svg {
    color: #00235C;
  }
}

.form-input {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9375rem;
  color: #1f2937;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #00235C;
    box-shadow: 0 0 0 3px rgba(0, 35, 92, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &.input-error {
    border-color: #ef4444;
    background: #fef2f2;
  }
}

/* Mensagem de Erro */
.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  color: #ef4444;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  animation: shake 0.3s ease;

  svg {
    flex-shrink: 0;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.error-fade-enter-active,
.error-fade-leave-active {
  transition: all 0.3s ease;
}

.error-fade-enter-from,
.error-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Botão de Login */
.btn-login {
  width: 100%;
  padding: 0.875rem 1.5rem;
  background: linear-gradient(135deg, #94bd23 0%, #7da51e 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(148, 189, 35, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .loading {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .spinner {
    animation: rotate 1s linear infinite;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsividade */
@media (max-width: 1024px) {
  .login-left {
    display: none;
  }

  .login-right {
    flex: 1;
  }
}

@media (max-width: 640px) {
  .login-right {
    padding: 1.5rem;
  }

  .login-card {
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }

  .card-title {
    font-size: 1.5rem;
  }

  .card-subtitle {
    font-size: 0.875rem;
  }

  .form-input {
    font-size: 0.875rem;
    padding: 0.75rem 0.875rem;
  }
}
</style>